export default __webpack_public_path__ + "static/media/hht1_ep13_timeline_q02_b_q04_b.f07c6ff6.png";